"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const th_1 = __importDefault(require("date-fns/locale/th")); //
const dateThTH = {
    name: 'thTH',
    locale: th_1.default
};
exports.default = dateThTH;
